export interface IDraggable {
	onDragStart(event): void;
	onDragEnd(event): void;
}

export interface IDroppable {
	onDrop(event): void;
	onDragEnter(event: Event): void;
	onDragOver(event: any): void;
	onDragLeave(event: Event): void;
}

export interface IDraggableHandler {
	onDragStart(event, data: any): void;
	onDragEnd(event, data: any): void;
}

export interface IDroppableHandler {
	onDragEnter(event: any, dragTarget: any): void;
	onDragLeave(event: Event, dragTarget: any): void;
	onDrop(event, dropTarget: any): void;
}

export abstract class HtmlDrag implements IDraggable {
	onDragStart(event: any): void {
		if (event.stopPropagation) {
			event.stopPropagation();
		}
		event.dataTransfer.effectAllowed = 'move';
	}

	onDragEnd(event: any): void {}

	bindDragEvents(element: Element) {
		element.addEventListener('dragstart', this.onDragStart.bind(this), false);
		element.addEventListener('dragend', this.onDragEnd.bind(this), false);
	}
}

export abstract class HtmlDrop implements IDroppable {
	onDragEnter(event: DragEvent) {
		event.stopPropagation();
		event.preventDefault(); // Necessary. Allows us to drop.
		const element = event.target as HTMLElement;
		element.classList.add('over');
	}

	onDragOver(event: DragEvent) {
		event.stopPropagation();
		event.preventDefault(); // Necessary. Allows us to drop.
		//event.dataTransfer.dropEffect = 'move';
	}

	onDrop(event: DragEvent) {
		event.preventDefault();
		event.stopPropagation(); // stops the browser from redirecting.
	}

	onDragLeave(event: DragEvent) {
		const element = event.target as HTMLElement;
		element.classList.remove('over');
	}

	bindDropEvents(element: Element) {
		element.addEventListener('dragenter', this.onDragEnter.bind(this), false);
		element.addEventListener('dragover', this.onDragOver.bind(this), false);
		element.addEventListener('dragleave', this.onDragLeave.bind(this), false);
		element.addEventListener('drop', this.onDrop.bind(this), false);
	}
}
